import React from 'react';
import { Trash2Icon } from 'lucide-react';
interface MemoryRowProps {
  title: string;
  meta: React.ReactNode;
  label?: string;
  /** Primary actions instead of "Vergeet" (e.g. for proposals) */
  actions?: React.ReactNode;
  onForget?: () => void;
}

/** One remembered thing: the text first, provenance underneath, an explicit way to forget it. */
export function MemoryRow({
  title,
  meta,
  label,
  actions,
  onForget
}: MemoryRowProps) {
  return <li className="grid gap-3 py-4 sm:grid-cols-[8rem_minmax(0,1fr)_auto] sm:items-start sm:gap-6" data-id="element-192" data-mp="2m4yruj5ajccb">
      <span className="text-[12px] font-medium text-ink-muted sm:pt-0.5" data-id="element-193" data-mp="2ha2pap2fh6ky">{label}</span>
      <div className="min-w-0" data-id="element-194" data-mp="2cdc9m2ujcd02">
        <p className="text-[15px] leading-relaxed text-ink" data-id="element-195" data-mp="27dzphpv1tk16">{title}</p>
        <div className="mt-1 flex flex-wrap items-center gap-x-2 gap-y-1 text-[12px] text-ink-muted" data-id="element-196" data-mp="27fssmv6gdm4f">{meta}</div>
      </div>
      <div className="flex items-center gap-2 sm:justify-end" data-id="element-197" data-mp="1ydb7yl6g51jj">
        {actions}
        {onForget && <button type="button" onClick={onForget} className="inline-flex h-8 items-center gap-1.5 whitespace-nowrap rounded-full px-3 text-[12px] font-medium text-ink-muted transition-colors duration-150 hover:bg-white/[0.06] hover:text-ink" data-id="element-198" data-mp="1jjqgddhor00k">
            <Trash2Icon className="h-3.5 w-3.5" aria-hidden data-id="element-199" data-mp="1ekdk624xcglb" /> Vergeet
          </button>}
      </div>
    </li>;
}